import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-searcher',
  templateUrl: './loading-searcher.component.html',
  styleUrls: ['./loading-searcher.component.css']
})
export class LoadingSearcherComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
